import { Injectable } from '@angular/core';
import { DsconfigService, RestConnService, StorageService } from '@services/services.module';
import { Observable } from 'rxjs';
import { DayData, ImputationsData } from '../calendar-day/calendar-day.model';
import { Constants } from '@app/constants/constants';

@Injectable()
export class ModalDayService {
  private imputation_day: object;
  private imputations: object;

  constructor(
    private dsConfig: DsconfigService,
    private _res: RestConnService,
    private storage: StorageService,
  ) {
    this.imputation_day = {
      'imputation_day': dsConfig.getUrlBase() + '/ess/v1/employee/imputation/daily'
    };
    this.imputations = {
      'imputations': dsConfig.getUrlBase() + '/ess/v1/imputation/list'
    };
  }

  saveSelectDay(inputSaveEmployee: DayData): Observable<any> {
    return this._res
      .post('imputation_day', {...inputSaveEmployee, ...{
        name: this.storage.get(Constants.UserData.employeeName),
        email: this.storage.get(Constants.UserData.email),
        employeeNumber: this.storage.get(Constants.UserData.employeeNumber),
        profileId: this.storage.get(Constants.UserData.profileId)
      }},
        {
          collection: this.imputation_day
        }
      );
  }
  deleteImputationSelected(inputationSelected: ImputationsData): Observable<any> {
    return this._res
      .post('imputations', {...{imputations: [inputationSelected.imputationId]}, ...{
        name: this.storage.get(Constants.UserData.employeeName),
        email: this.storage.get(Constants.UserData.email),
        employeeNumber: this.storage.get(Constants.UserData.employeeNumber),
        profileId: this.storage.get(Constants.UserData.profileId)
      }},
        {
          collection: this.imputations
        }
      );
  }
}
